
export default function getCarrier(state) {
  return state.carrier;
}
